import axios from 'axios';
import storage from 'good-storage';
import { Notification } from 'element-ui';
import router from '../router';
import { curUrl } from "./index"
let api = curUrl;
// import api from './apifolder/index';
// import StatesData from '../components/common/js/StatesData';
import { illegalProp, operationPost } from './InterceptorFunc'
import Vue from 'vue';

  // 响应拦截器

// axios 取消请求
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

function axiosInterceptors() {
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  axios.interceptors.request.use((request) => {
    // 拉新配置不取消请求
    if (request.url !== `${api.laxinApi}/update-laxin2023-award-config/` && request.url !== `${api.matchInfoAPI}/v1/match/add` && request.url !== `${api.matchInfoAPI}/v1/match/update`) {
    // 取消请求
      if (!illegalProp(request, source)) {
      // source.cancel('检测到有非法的道具配置, 请检查道具配置,修改后重试!')
        const msg = '<i style="color: #F56C6C;">检测到有非法的道具配置, 请检查道具配置, 修改后重新提交! </i>'
        source.cancel(msg)
        source = CancelToken.source()
      }
    }

    // 测试环境的game及 game area list 不加x-xq5-jwt
    if (((request.url.match('http://123.206.215.185:8003/v1/game/list'))) || ((request.url.match('http://123.206.215.185:8003/v1/game/area/list')))) {
      return request
    }
    request.headers['x-xq5-jwt'] = storage.get('token') ? storage.get('token') : '';
    return request
  }, (error) => {
    Notification.error({
      title: '错误',
      message: `${error.config.url}请求败，请检查参数是否正确。原因${error}`,
      duration: 6000,
    });
    return Promise.resolve(error);
  });
  axios
    .interceptors
    .response
    .use((response) => {
      if(window.localStorage.getItem('isUseIframeToken')) {
        window.localStorage.setItem('isUseIframeToken', '')
      }
      if (response.config.url !== `${api.xyxNewDataApi}/background/operation/report/`) {
      // console.log(response, '-----------response');
      // 正式环境和测试环境上报, 本地环境不上报
        if (window.location.hostname === 'wxopapp.xq5.com' || window.location.hostname === 'test.wxopapp.xq5.com') {
          console.log('当前为不是本地环境, 上报行为信息!');
          operationPost(response)
        }// 区分判断请求菜单的zlink接口
        if (response.config.url.includes('api/common/v1/permission/account') && response.data.code === 0) return response;
        if (response.data.message && response.data.message !== 'success') {
          console.log(response, '错误24')
          Notification.error({
            title: '错误24',
            message: response.data.message,
            duration: 6000,
          });
        }
        if (response.data.tip_id && response.data.tip_id !== 0) {
          console.log(response, '错误23')
          Notification.error({
            title: '错误23',
            message: response.data.tip,
            duration: 6000,
          });
        }
        if (response.data.errno !== undefined) {
          // 广告ID配置不报错
          if (response.config.url !== `${api.drawLotApi}/ad/edit` && Number(response.data.errno) !== 0) {
            console.log(response, '错误22')
            Notification.error({
              title: '错误22',
              message: response.data.errmsg,
              duration: 6000,
            });
            return response
          }
        // 权限验证错误,删token,刷新页面
          if (response.data.errmsg === 'unauthorized') {
            storage.remove('token');
            storage.set('token', '');
            window.localStorage.setItem('tokenall', '');
            setTimeout(() => {
              router.replace('/');
              window.location.reload();
            }, 1000);
            return response
          }
        }
      }
      return response;
    }, async(error) => {
      console.log('error.5555555555555555555', error);

      if (error.config.url === `${api.xyxNewDataApi}/background/operation/report/`) {
        return Promise.resolve(error);
      }
      if (!error.response) {
        Notification.error({
          title: '错误1',
          dangerouslyUseHTMLString: true,
          message: `${error.config}响应失败，请刷新浏览器重试。原因${error}`,
          duration: 6000,
        });
        // console.log(error.config.url, '后端接口响应失败，请刷新浏览器重试。错误原因')
        return Promise.resolve(error);
      }
      switch (error.response.status) {
        case 200:
          Notification.error({
            title: '成功',
            message: '操作成功',
            duration: 5000,
          });
          break;
        case 400:
          Notification.error({
            title: '错误2',
            message: `${error.response.status}传递参数出现错误:${error.response.data.errmsg}`,
            duration: 5000,
          });
          break;
        case 401:
          var tokenEndTime = await Vue.prototype.$Auth.getTokenEndTime();
          var iframeToken =  await Vue.prototype.$Auth.getZonstAuth();
          console.log('tokenEndTime', tokenEndTime, new Date().getTime(), new Date(Number(tokenEndTime)));
          console.log('iframeToken', iframeToken);
          // 如果是没用iframeToken报的401并且iframeToken未过期尝试重新刷新
          if(!window.localStorage.getItem('isUseIframeToken') && tokenEndTime && iframeToken && (Number(tokenEndTime) >= new Date().getTime())) {
            window.localStorage.setItem('isUseIframeToken', true)
            storage.set('token', iframeToken);
            axios.defaults.headers.common['x-xq5-jwt'] = iframeToken;
            // 页面刷新一次
            window.location.reload();
          } else {
            window.localStorage.setItem('isUseIframeToken', '')
            Vue.prototype.$Auth.removeZonstAuth();
            Notification.error({
              title: '错误3',
              message: '登录信息过期，跳转登陆页401',
              duration: 5000,
            });
            // alert('检测到无token或者token过期');
            // debugger;
            storage.remove('token');
            storage.set('token', '');
            window.localStorage.setItem('tokenall', '');
            setTimeout(() => {
              router.replace('/');
              window.location.reload();
            }, 1000);
          }
          break;
        case 403:
          Notification.error({
            title: '错误4',
            message: '您没有权限进行此操作403',
            duration: 5000,
          });
          break;
        case 404:
          Notification.error({
            title: '错误',
            message: '接口网址未找到404',
            duration: 5000,
          });
          break;
        case 500:
          Notification.error({
            title: '错误5',
            message: '后端服务器内部错误500',
            duration: 5000,
          });
          break;
        case 501:
          Notification.error({
            title: '错误6',
            message: '服务器不具备完成请求的功能(如无法识别请求方法)501',
            duration: 5000,
          });
          break;
        case 502:
          Notification.error({
            title: '错误7',
            message: '错误网关，收到无效响应502',
            duration: 5000,
          });
          break;
        case 503:
          Notification.error({
            title: '错误8',
            message: '后端服务暂不可用(超载或停机维护)503',
            duration: 5000,
          });
          break;
        case 504:
          Notification.error({
            title: '错误9',
            message: '网关超时504',
            duration: 5000,
          });
          break;
        case 505:
          Notification.error({
            title: '错误10',
            message: 'HTTP 版本不受支持505',
            duration: 5000,
          });
          break;
        case 204:
          Notification.error({
            title: '错误11',
            message: error.response.data.tip,
            duration: 5000,
          });
          break;
        default:
          Notification.error({
            title: '错误12',
            message: `错误码:${error.response.status}错误原因: ${error.response.data.errmsg} 未知错误！`,
            duration: 5000,
          });
          return Promise.reject(error);
      }
      return error;
    });
}

export default axiosInterceptors
